import React from "react";
import '../../../model/index.css';

const P2 = () => {
  return (
    <div className="my-container">
      <h1 className="highlight">The Red & Luna</h1>
      <div className="section">
        <h2>法国 南特</h2>
        <p className="store-info"></p>
        <img src="./partner/2/1.pic.jpg"  alt=""/>
        <img src="./partner/2/2.pic.jpg"  alt=""/>
        <img src="./partner/2/3.pic.jpg"  alt=""/>
        <img src="./partner/2/4.pic.jpg"  alt=""/>
        <img src="./partner/2/5.pic.jpg"  alt=""/>
      </div>
    </div>
  );
};

export default P2;
